var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-h"},[_vm._v(" 欢迎进入专项任务平台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }